import { EllipsedText } from '@gorila-shared-ui/components';
import { Avatar } from 'baseui/avatar';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useHover } from 'usehooks-ts';
import { useStyles } from '../../hooks/useStyles';
import { selectWorkspaceState, workspaceState } from '../../storage/app';
import { Workspace } from '../../types/workspace';

function WorkspaceItem({ data, index, style }: Readonly<ListChildComponentProps<Workspace[]>>) {
  const workspace = data[index];
  const { theme } = useStyles();
  const [selectedWorkspace, setSelectedWorkspace] = useRecoilState(workspaceState);
  const setSelectWorkspace = useSetRecoilState(selectWorkspaceState);
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedWorkspace?._id === workspace._id;

  const onSelectWorkspace = () => {
    setSelectedWorkspace(workspace);
    setSelectWorkspace(false);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      <ListItem
        artwork={() => (
          <Avatar
            name={workspace.name}
            src={workspace.logo}
            size={theme.sizing.scale850}
            overrides={{
              Root: {
                style: {
                  flexShrink: 0,
                },
              },
            }}
          />
        )}
        overrides={{
          Root: {
            props: {
              onClick: onSelectWorkspace,
            },
            style: {
              cursor: 'pointer',
              backgroundColor: isSelected
                ? theme.colors.backgroundTertiary
                : isHover
                  ? theme.colors.backgroundSecondary
                  : undefined,
            },
          },
        }}
      >
        <ListItemLabel description={workspace.rfc}>
          <EllipsedText inline>{workspace.name}</EllipsedText>
        </ListItemLabel>
      </ListItem>
    </span>
  );
}

export default memo(WorkspaceItem);
